import { IFeatureGroupBase } from '../../models/features';
import { IVentureBase } from '../../models/ventures';
import { IUserAssignmentBase, IUserBase } from '../../models/users';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IUpdateUserAvatarProps {
  userId: string;
  avatarData: FormData;
}

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
  host?: IUserBase;
  venture?: IVentureBase;
}

export interface IUpdatedUserAvatar extends IUserBase {
  userAssignments: IUserAssignment[];
}

export const updateUserAvatarsService = async ({
  avatarData,
  userId,
}: IUpdateUserAvatarProps): Promise<IUpdatedUserAvatar> => {
  const { data } = await jhsfBookingsApi.patch<IUpdatedUserAvatar>(
    `/avatars/users/${userId}`,
    avatarData,
  );

  return data;
};
